<div class="form-group">
    <label>{{to.label}}</label>
    <ng-select
        [addTag]="to.addTag"
        [appendTo]="to.appendTo"
        [bindLabel]="to.bindLabel"
        [bindValue]="to.bindValue"
        [clearable]="to.clearable"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [hideSelected]="to.hideSelected"
        [isOpen]="to.isOpen"
        [items]="to.options"
        [multiple]="to.multiple"
        [placeholder]="to.placeholder"
        [readonly]="to.readonly"
        (remove)="onRemove($event)"
    >
    </ng-select>
</div>
